import { render, staticRenderFns } from "./PaymentSettingInstallment.vue?vue&type=template&id=778a35fd&scoped=true&"
import script from "./PaymentSettingInstallment.vue?vue&type=script&lang=js&"
export * from "./PaymentSettingInstallment.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSettingInstallment.vue?vue&type=style&index=0&id=778a35fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778a35fd",
  null
  
)

export default component.exports